import { Injectable } from '@angular/core';

@Injectable()
export class SettingsService {

    private _localhost: boolean;

    constructor() {
        this._localhost = false;
    }

    obterHostBase(): string {

        let host: string;

        if (this._localhost) {
            host = 'http://localhost:8080/';
        } else {
            host = 'https://flagapi.hominisistemas.com.br';
        }
        return host;
    }

}




// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/settings.service.ts